export default "__VITE_ASSET__DsDtf9rQ__"